"use client";

import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import { usePageLoading } from "@/hooks/usePageLoading.hook";

interface UseAnimatedLogoProps {
  onClick?: () => void;
}

export const useAnimatedLogo = (props?: Readonly<UseAnimatedLogoProps>) => {
  const { onClick } = props || {};
  const { setIsAnimating, setIsLoading } = usePageLoading();
  const router = useRouter();
  const animationTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const loadingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    // Clear any existing timeouts
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current);
    }
    if (loadingTimeoutRef.current) {
      clearTimeout(loadingTimeoutRef.current);
    }

    setIsLoading(true);
    setIsAnimating(true);
   
    // Ensure animation stops after completion
    animationTimeoutRef.current = setTimeout(() => {
      setIsAnimating(false);
      animationTimeoutRef.current = null;
    }, 2000);
    
    loadingTimeoutRef.current = setTimeout(() => {
      setIsLoading(false);
      loadingTimeoutRef.current = null;
    }, 3000);
    
    if (onClick) {
      onClick();
    } else {
      router.push("/");
    }
  };

  return {
    handleClick,
  };
};

